import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Modal } from "react-bootstrap";
import Form from "components/react-validation/components/form";
import Input from "components/react-validation/components/input";
import { Panel, Tab, Row, Col } from "react-bootstrap";
import * as ProjectActionType from "Projects/constants";
import { Dropdown } from "../../../components/Dropdown/Dropdown";
import { v4 as uuidv4 } from "uuid";
import Moment from "moment";
import Datetime from "react-datetime";
import word from "../../../assets/img/file_word.png";
import excel from "../../../assets/img/file_excel.png";
import pdf from "../../../assets/img/file_pdf.png";
import ppt from "../../../assets/img/file_pp.png";
import video from "../../../assets/img/file_video.png";
import other from "../../../assets/img/file_other.png";
import { AppSettings } from "../../../constants";
import "../../inventoryAddEditModal.scss";
import { Link } from "react-router-dom";
import heic2any from "heic2any";
import AIScanViewEdit from "./AIScanViewEdit";
import {
  convertTiffToJpeg,
  getTruncatedFilename,
} from "../../../utils/ImageConvertor";

const GroupCategory = {
  videoFile: { id: 2, name: "Video" },
  profileImages: { id: 1, name: "Image" },
  registrationImages: { id: 3, name: "RegistrationManual" },
  userCareManualImages: { id: 4, name: "UserCareManual" },
  limitedWarrantyImages: { id: 5, name: "LimitedWarranty" },
  receiptsImages: { id: 6, name: "Receipts" },
  serviceContractOthersImages: { id: 7, name: "ServiceContracts" },
  serialImage: { id: 8, name: "SerialImage" },
};

export class InventoryEditItemModal extends Component {
  static propTypes = {
    isOpen: PropTypes.bool,
    closeModal: PropTypes.func,
    onDrop: PropTypes.func,
    accept: PropTypes.string,
    dispatch: PropTypes.func,
    lot: PropTypes.object,
    fetchInventoryCategoriesHo: PropTypes.func,
    isEdit: PropTypes.bool,
    itemDetails: PropTypes.object,
    homeownerLotSelectList: PropTypes.array,
    HomeownerInventoryCategory: PropTypes.array,
    getInventoryDetails: PropTypes.func,
    fetchInventoryCategories: PropTypes.func,

    onDrop: PropTypes.func,
    accept: PropTypes.string,
    dispatch: PropTypes.func,
    lot: PropTypes.object,
    isEdit: PropTypes.bool,
    homeownerLotSelectList: PropTypes.array,
    HomeownerInventoryCategory: PropTypes.array,
    getInventoryDetails: PropTypes.func,
    inventoryItemId: PropTypes.string,
    onChangeMode: PropTypes.func,
  };

  constructor(props) {
    super(props);
    this.state = {
      isDragging: false,
      profileImages: [],
      uploading: false,
      uploadProgress: 0,
      selectedLotId: null,
      lotDetails: null,
      activeKey: "1",
      showDocumentInfo: true,
      lot: this.props.lot,
      editingState: {},
      registration: "",
      registrationImages: [],
      registrationImagesError: "",
      uploadResults: [],
      userCareManual: "",
      userCareManualImages: [],
      userCareManualImagesError: "",
      showBasicDetails: true,
      showItemDetail: false,
      showLinkDocument: false,
      showReceiptsotherDocs: false,
      limitedWarranty: "",
      limitedWarrantyImages: [],
      limitedWarrantyImagesError: "",
      expandedPanels: {},
      editCategoryIndex: null,
      name: "",
      itemCategory: null,
      property: null,
      smartApp: null,
      smartAppList: [],
      locationInHome: "",
      profileImagesError: "",
      deletedFiles: [],
      receiptsImages: [],
      receiptsImagesError: "",
      serviceContractOthersImages: [],
      serviceContractOthersImagesError: "",
      generalDescription: "",
      categoryListing: [],
      propertList: null,
      locationInHomeList: [
        { text: "Kitchen", value: "Kitchen" },
        { text: "Bedroom", value: "Bedroom" },
        { text: "Store Room", value: "Store Room" },
        { text: "Living Area", value: "Living Area" },
        { text: "Porch", value: "Porch" },
        { text: "Backyard", value: "Backyard" },
      ],
      typeOfPurchaseList: [
        { text: "Builder Installed", value: "Builder Installed" },
        { text: "Maintenance", value: "Maintenance" },
        { text: "Capital Management", value: "Capital Management" },
        { text: "Equipment", value: "Equipment" },
        { text: "Personal Belonging", value: "Personal Belonging" },
      ],
      typeOfPurchase: null,
      videoFile: null,
      videoPreviewUrl: "",
      videoError: "",
      warrantyError: "",
      appName: "",
      androidURL: "",
      iosURL: "",
      appError: "",
      registrationMenu: false,
      userCareMenu: false,
      limitedWarrantyMenu: false,
      error: "",
      dynamicSegment: "",
      tab: "",
      toolSelection: "",
      showOtherDocs: false,
      otherImages: [],
      serialImage: null,
      serialImagePreviewUrl: "",
      serialImageError: "",
      showAIScan: false,
    };
  }

  componentDidMount() {
    this.onFetchListCategory();
    if (this.props.itemDetails) {
      this.populateFormWithItemDetails();
    }
    const projectId = window.location.href;

    const editPathMatch = projectId.match(/\/edit\/([^?]+)/);
    const dynamicSegment = editPathMatch ? editPathMatch[1] : "";
    const queryParams = new URLSearchParams(projectId);
    const tab = queryParams.get("tab");
    const toolSelection = queryParams.get("toolSelection");
    this.setState({
      dynamicSegment,
      tab,
      toolSelection,
    });
  }
  componentDidUpdate(prevProps) {
    const itemChanged =
      this.props.itemDetails &&
      this.props.itemDetails !== prevProps.itemDetails;

    const modalJustOpened = !prevProps.isOpen && this.props.isOpen;

    if (itemChanged || modalJustOpened) {
      this.onFetchListCategory();
      this.populateFormWithItemDetails();
    }
  }

  populateFormWithItemDetails = () => {
    const { itemDetails } = this.props;
    if (!itemDetails) return;

    const {
      name,
      description,
      mfgName,
      modelNo,
      serialNo,
      locationInHome,
      purchaseDate,
      price,
      typeofPurchase,
      warrantyStartDate,
      warrantyEndDate,
      smartAppId,
      registrationManual = [],
      userCareManual = [],
      limitedWarranty = [],
      receipts = [],
      serviceContracts = [],
      video = [],
      others = [],
    } = itemDetails;

    // Determine text/image toggle
    const isText = (docs) =>
      Array.isArray(docs) &&
      docs.length === 1 &&
      typeof docs[0] === "object" &&
      docs[0].docsCategory === "Text";

    const isImage = (docs) =>
      Array.isArray(docs) &&
      docs.some((item) => {
        const url = item.textAndUrl || item.url || "";
        const isImgCat = item.docsCategory === "Images";
        const isImgExt = /\.(jpg|jpeg|png|gif|svg|webp|heic|heif)$/i.test(url);
        return (isImgCat || isImgExt) && url;
      });

    const matchingProperty = this.state.propertList
      ? this.state.propertList.data.find(
          (prop) => prop.value === itemDetails.lotId,
        )
      : {};
    const categoryDetail = this.state.formattedCategories
      ? this.state.formattedCategories.find(
          (cat) => cat.id == itemDetails.categoryId,
        )
      : {};
    this.setState({
      itemName: name || "",
      itemCategory: categoryDetail,
      generalDescription: description || "",
      property: matchingProperty,
      mfgName: mfgName || "",
      model: modelNo || "",
      serial: serialNo || "",
      serialImage: itemDetails.serialNoImage || null,
      serialImagePreviewUrl: itemDetails.serialNoImage
        ? itemDetails.serialNoImage.url
        : "",
      profileImages: itemDetails.image,
      locationInHome: locationInHome || "",
      purchaseDate: purchaseDate ? new Date(purchaseDate) : null,
      price: price || "",
      typeOfPurchase: typeofPurchase
        ? { text: typeofPurchase, value: typeofPurchase }
        : null,
      warrantyStart: warrantyStartDate ? new Date(warrantyStartDate) : null,
      warrantyEnd: warrantyEndDate ? new Date(warrantyEndDate) : null,
      registration: isText(registrationManual)
        ? registrationManual[0].textAndUrl
        : "",
      registrationImages: isImage(registrationManual) ? registrationManual : [],
      showRegistrationTextField: isText(registrationManual),
      showRegistrationUploadImage:
        !isText(registrationManual) && isImage(registrationManual),

      userCareManual: isText(userCareManual)
        ? userCareManual[0].textAndUrl || ""
        : "",
      userCareManualImages: isImage(userCareManual) ? userCareManual : [],
      showuserCareManualTextField: isText(userCareManual),
      showuserCareManualUploadImage:
        !isText(userCareManual) && isImage(userCareManual),

      limitedWarranty: isText(limitedWarranty)
        ? limitedWarranty[0].textAndUrl
        : "",
      limitedWarrantyImages: isImage(limitedWarranty) ? limitedWarranty : [],
      showLimitedWarrantyTextField: isText(limitedWarranty),
      showLimitedWarrantyImage:
        !isText(limitedWarranty) && isImage(limitedWarranty),

      receiptsImages: receipts,
      serviceContractOthersImages: serviceContracts,
      videoFile: video.length ? video[0] : null,
      videoPreviewUrl: video.length ? video[0].url : "",
      appName: itemDetails.appName || "",
      androidURL: itemDetails.androidUrl || "",
      iosURL: itemDetails.iosUrl || "",
      smartApp: smartAppId,
      otherImages: others.length ? others : [],
    });
  };

  resetForm = () => {
    this.setState({
      appError: "",
      isDragging: false,
      profileImages: [],
      uploading: false,
      uploadProgress: 0,
      selectedLotId: null,
      lotDetails: null,
      activeKey: "1",
      showDocumentInfo: true,
      lot: this.props.lot,
      editingState: {},
      registration: "",
      registrationImages: [],
      registrationImagesError: "",
      uploadResults: [],
      userCareManual: "",
      userCareManualImages: [],
      userCareManualImagesError: "",
      showBasicDetails: true,
      showItemDetail: false,
      showLinkDocument: false,
      showReceiptsotherDocs: false,
      limitedWarranty: "",
      limitedWarrantyImages: [],
      limitedWarrantyImagesError: "",
      profileImagesError: "",
      expandedPanels: {},
      editCategoryIndex: null,
      itemName: "",
      itemCategory: null,
      property: null,
      smartApp: null,
      locationInHome: "",
      receiptsImages: [],
      receiptsImagesError: "",
      serviceContractOthersImages: [],
      serviceContractOthersImagesError: "",
      generalDescription: "",
      typeOfPurchase: null,
      videoFile: null,
      videoPreviewUrl: "",
      videoError: "",
      warrantyStart: null,
      warrantyEnd: null,
      showRegistrationTextField: false,
      showRegistrationUploadImage: false,
      showuserCareManualTextField: false,
      showuserCareManualUploadImage: false,
      showLimitedWarrantyTextField: false,
      showLimitedWarrantyImage: false,
      model: "",
      price: "",
      mfgName: "",
      purchaseDate: null,
      serialImage: null,
      serialImagePreviewUrl: "",
      serialImageError: "",
    });
  };

  togglePanel = (panelName) => {
    this.setState((prevState) => ({
      [panelName]: !prevState[panelName],
    }));
  };

  handleTypeMenu = (fieldname) => {
    this.setState(
      {
        [fieldname]: !this.state[fieldname],
      },
      () => {
        console.log([fieldname], this.state[fieldname]);
      },
    );
  };

  handleInputChange = (event) => {
    if (!event || !event.target) return;
    const { name, value } = event.target;
    if (name === "itemName" && value.length > 150) {
      this.setState({ error: "Name must be 150 characters or fewer." });
    } else {
      this.setState({
        [name]: value,
        error: "",
      });
    }
    this.setState({ [name]: value }, () => {});
  };

  onChangepurchaseDate = (date) => {
    this.setState({ purchaseDate: date });
  };
  onChangeWarrantyStart = (date) => {
    this.setState({ warrantyStart: date });
  };

  onChangewarrantyEnd = (date) => {
    const { warrantyStart } = this.state;

    let error = "";
    if (warrantyStart && date && new Date(date) < new Date(warrantyStart)) {
      error = "Warranty end date cannot be before start date.";
    }

    this.setState({
      warrantyEnd: date,
      warrantyError: error,
    });
  };

  onSelectChange = (event, name) => {
    this.setState({
      [name]: event.value,
    });
  };

  getUploadFile = async (files) => {
    if (!files || files.length === 0) return;

    const fieldName = files[0].fieldName;
    this.setState({ loading: true });

    try {
      const uploaded = await Promise.all(
        files.map((file) => this.uploadFileDirectly(file)),
      );

      const validUploaded = uploaded.filter((file) => file.uploadedFileId);

      this.setState((prevState) => {
        const prev = prevState[fieldName] || [];
        const existingKeys = new Set(
          prev.map((file) => `${file.name}_${file.size}_${file.uploadedFileId}`),
        );
        const newFiles = validUploaded.filter(
          (file) =>
            !existingKeys.has(`${file.name}_${file.size}_${file.uploadedFileId}`),
        );
        const stateUpdates = {
          [fieldName]: [...prev, ...newFiles],
          [`${fieldName}Error`]: "",
          loading: false,
        };
        if (fieldName === "registrationImages") stateUpdates.registration = "";
        if (fieldName === "userCareManualImages") stateUpdates.userCareManual = "";
        if (fieldName === "limitedWarrantyImages") stateUpdates.limitedWarranty = "";
        return stateUpdates;
      }, () => {
        if (fieldName === "profileImages" && this.fileInput) {
          this.fileInput.value = "";
        }
      });
    } catch (error) {
      this.setState({
        [`${fieldName}Error`]: "File upload failed.",
        loading: false,
      });
    }
  };

  downloadAndUploadFiles = async (urls, fieldName, groupCategory) => {
    if (!urls || urls.length === 0) return;

    const fileEntries = [];

    for (const url of urls) {
      // Extract filename from URL
      let fileName = url.split("/").pop().split("?")[0] || "file";

      try {
        const response = await fetch(url);
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        const blob = await response.blob();
        const contentType = blob.type || "application/octet-stream";

        // Add extension based on content type if missing
        if (!fileName.includes(".")) {
          const extMap = {
            "image/jpeg": ".jpg",
            "image/png": ".png",
            "image/webp": ".webp",
            "image/gif": ".gif",
            "application/pdf": ".pdf",
          };
          fileName += extMap[contentType] || "";
        }

        const file = new File([blob], fileName, {
          type: contentType,
          lastModified: Date.now(),
        });

        fileEntries.push({
          id: uuidv4(),
          name: file.name,
          size: file.size,
          type: file.type,
          file,
          thumbnailUrl: contentType.startsWith("image/") ? url : undefined,
          groupCategoryId: groupCategory.id,
          groupCategoryName: groupCategory.name,
          fieldName,
        });
      } catch (error) {
        console.warn(`Failed to download file from ${url}:`, error);
        // Fallback: create a placeholder entry so the user sees something in the UI
        const ext = fileName.includes(".")
          ? fileName.split(".").pop().toLowerCase()
          : "";
        const mimeMap = {
          pdf: "application/pdf",
          jpg: "image/jpeg",
          jpeg: "image/jpeg",
          png: "image/png",
          webp: "image/webp",
          gif: "image/gif",
          doc: "application/msword",
          docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        };
        const fallbackType = mimeMap[ext] || "application/octet-stream";
        // Create a small placeholder blob so the entry renders in the file list
        const placeholderBlob = new Blob([""], { type: fallbackType });
        const placeholderFile = new File(
          [placeholderBlob],
          fileName || "document",
          {
            type: fallbackType,
            lastModified: Date.now(),
          },
        );

        fileEntries.push({
          id: uuidv4(),
          name: placeholderFile.name,
          size: placeholderFile.size,
          type: placeholderFile.type,
          file: placeholderFile,
          url: url, // Store the original URL for reference
          groupCategoryId: groupCategory.id,
          groupCategoryName: groupCategory.name,
          fieldName,
        });
      }
    }

    if (fileEntries.length > 0) {
      // For profileImages, replace instead of append since only 1 is allowed
      if (fieldName === "profileImages") {
        this.setState({ profileImages: [] }, () => {
          this.getUploadFile(fileEntries);
        });
      } else {
        this.getUploadFile(fileEntries);
      }
    }
  };

  handleAIScanPrefill = (prefillData) => {
    // Clear previous prefill data first, then set new values
    const stateUpdate = {
      showAIScan: false,
      showBasicDetails: true,
      showItemDetail: true,
      showLinkDocument: true,
      showReceiptsotherDocs: true,
    };

    // Text fields
    if (prefillData.productName) stateUpdate.itemName = prefillData.productName;
    if (prefillData.manufacturer)
      stateUpdate.mfgName = prefillData.manufacturer;
    if (prefillData.modelNumber) stateUpdate.model = prefillData.modelNumber;
    if (prefillData.serialNumber) stateUpdate.serial = prefillData.serialNumber;
    if (prefillData.productDescription)
      stateUpdate.generalDescription = prefillData.productDescription;
    if (prefillData.price) stateUpdate.price = prefillData.price;
    if (prefillData.warrantyText)
      stateUpdate.limitedWarranty = prefillData.warrantyText;
    if (prefillData.registrationLink)
      stateUpdate.registration = prefillData.registrationLink;
    if (prefillData.smartAppName)
      stateUpdate.appName = prefillData.smartAppName;
    if (prefillData.smartAppIOS) stateUpdate.iosURL = prefillData.smartAppIOS;
    if (prefillData.smartAppAndroid)
      stateUpdate.androidURL = prefillData.smartAppAndroid;

    // Dates are always blank on AI prefill
    stateUpdate.purchaseDate = null;
    stateUpdate.warrantyStart = null;
    stateUpdate.warrantyEnd = null;

    // Trigger state update
    this.setState(stateUpdate, () => {
      // Handle File Downloads & Uploads (after state reset)

      // Product Images -> profileImages
      if (
        prefillData.productImageUrls &&
        prefillData.productImageUrls.length > 0
      ) {
        this.downloadAndUploadFiles(
          prefillData.productImageUrls,
          "profileImages",
          GroupCategory.profileImages,
        );
      }

      // Limited Warranty Links -> limitedWarrantyImages
      if (
        prefillData.limitedWarrantyUrls &&
        prefillData.limitedWarrantyUrls.length > 0
      ) {
        this.downloadAndUploadFiles(
          prefillData.limitedWarrantyUrls,
          "limitedWarrantyImages",
          GroupCategory.limitedWarrantyImages,
        );
      }

      // Use & Care Manual Links -> userCareManualImages
      if (
        prefillData.useCareManualUrls &&
        prefillData.useCareManualUrls.length > 0
      ) {
        this.downloadAndUploadFiles(
          prefillData.useCareManualUrls,
          "userCareManualImages",
          GroupCategory.userCareManualImages,
        );
      }

      // Receipts & Other Docs -> serviceContractOthersImages
      if (
        prefillData.receiptsDocsUrls &&
        prefillData.receiptsDocsUrls.length > 0
      ) {
        this.downloadAndUploadFiles(
          prefillData.receiptsDocsUrls,
          "serviceContractOthersImages",
          GroupCategory.serviceContractOthersImages,
        );
      }

      // Scanned product label images → Service Contract & Others
      if (prefillData.serviceContractFiles && prefillData.serviceContractFiles.length > 0) {
        const fileEntries = prefillData.serviceContractFiles.map((file) => ({
          id: uuidv4(),
          name: file.name,
          size: file.size,
          type: file.type,
          file,
          groupCategoryId: GroupCategory.serviceContractOthersImages.id,
          groupCategoryName: GroupCategory.serviceContractOthersImages.name,
          fieldName: "serviceContractOthersImages",
        }));
        this.getUploadFile(fileEntries);
      }

      // Receipt Photo File (Blob) -> receiptsImages
      if (prefillData.receiptPhotoFile) {
        const file = prefillData.receiptPhotoFile;
        const fileEntry = {
          id: uuidv4(),
          name: file.name,
          size: file.size,
          type: file.type,
          file,
          groupCategoryId: GroupCategory.receiptsImages.id,
          groupCategoryName: GroupCategory.receiptsImages.name,
          fieldName: "receiptsImages",
        };
        this.getUploadFile([fileEntry]);
      }
    });
  };

  uploadFileDirectly = async (fileObj) => {
    const formData = new FormData();
    formData.append("File", fileObj.file);
    formData.append("GroupName", fileObj.groupCategoryId);

    const response = await fetch(
      `${AppSettings.CURRENT_SITE_URI}/api/v2/builder/inventory/items/add/file
`,
      {
        method: "POST",
        body: formData,
        headers: {
          Authorization: `Bearer ${localStorage.getItem(AppSettings.S1_TOKEN)}`,
        },
      },
    );

    const result = await response.json();

    return {
      ...fileObj,
      uploadedFileId: result.data,
    };
  };

  handleUploadImages = async (e, fieldName) => {
    const files = Array.from(e.target.files);
    const current = this.state[fieldName] || [];
    const MAX_FILE_SIZE = 100 * 1024 * 1024; // 100MB
    const MAX_FILES_LIMIT = 3;
    if (
      [
        "registrationImages",
        "userCareManualImages",
        "limitedWarrantyImages",
        "receiptsImages",
      ].includes(fieldName) &&
      files.length + current.length > MAX_FILES_LIMIT
    ) {
      this.setState({
        [`${fieldName}Error`]: `You can only upload up to ${MAX_FILES_LIMIT} files.`,
      });
      return;
    }
    const imageTypes = [
      "image/png",
      "image/jpeg",
      "image/jpg",
      "image/svg+xml",
      "image/heic",
      "image/heif",
      "image/gif",
      "image/tiff",
      "image/webp",
    ];
    const imageExtensions = [
      ".png",
      ".jpg",
      ".jpeg",
      ".svg",
      ".heic",
      ".heif",
      ".gif",
      ".tiff",
      ".webp",
    ];
    const documentTypes = [
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "text/plain",
      "application/vnd.ms-powerpoint",
      "application/vnd.openxmlformats-officedocument.presentationml.presentation",
      "application/vnd.apple.numbers",
      "application/vnd.apple.pages",
    ];
    const allowedTypesMap = {
      registrationImages: [...imageTypes, ...documentTypes],
      userCareManualImages: [...imageTypes, ...documentTypes],
      limitedWarrantyImages: [...imageTypes, ...documentTypes],
      receiptsImages: [...imageTypes, ...documentTypes],
      serviceContractOthersImages: [...imageTypes, ...documentTypes],
    };
    const allowedTypes = allowedTypesMap[fieldName];
    const documentExtensions = [
      ".pdf",
      ".doc",
      ".docx",
      ".xls",
      ".xlsx",
      ".txt",
      ".ppt",
      ".pptx",
      ".numbers",
      ".pages",
    ];
    const accepted = await Promise.all(
      files.map(async (file) => {
        const fileExtension = file.name
          .substring(file.name.lastIndexOf("."))
          .toLowerCase();
        const isAllowedType =
          allowedTypes.includes(file.type) ||
          imageExtensions.includes(fileExtension) ||
          documentExtensions.includes(fileExtension);
        const isSizeValid = file.size <= MAX_FILE_SIZE;
        if (!isSizeValid) return null;

        if (fileExtension === ".heic" || fileExtension === ".heif") {
          try {
            const convertedBlob = await heic2any({
              blob: file,
              toType: "image/jpeg",
              quality: 0.8,
            });
            const newFileName = `${file.name.split(".")[0]}.jpeg`;
            return new File([convertedBlob], newFileName, {
              type: "image/jpeg",
              lastModified: file.lastModified,
            });
          } catch (error) {
            console.error("HEIC conversion failed:", error);
            return null;
          }
        }

        if (
          fileExtension === ".tiff" ||
          fileExtension === ".tif" ||
          file.type === "image/tiff"
        ) {
          try {
            const jpegBlob = await convertTiffToJpeg(file);
            const newFileName = `${file.name.split(".")[0]}.jpeg`;
            const jpegFile = new File([jpegBlob], newFileName, {
              type: "image/jpeg",
              lastModified: file.lastModified,
            });
            return jpegFile;
          } catch (error) {
            console.error("TIFF conversion failed:", error);
            return null;
          }
        }
        return isAllowedType ? file : null;
      }),
    ).then((results) => results.filter(Boolean));
    if (accepted.length !== files.length) {
      let errorMessage;
      if (
        [
          "registrationImages",
          "userCareManualImages",
          "limitedWarrantyImages",
          "receiptsImages",
          "serviceContractOthersImages",
        ].includes(fieldName)
      ) {
        errorMessage =
          "Only .pdf, .doc, .docx, .xls, .xlsx, .txt, .jpg, .jpeg, .png, .heic, .gif, .ppt, .pptx, .numbers, .pages, .tiff, .webp files under 100MB are allowed.";
      } else {
        errorMessage =
          "Only SVG, PNG, JPG, JPEG, WEBP files under 100MB are allowed.";
      }

      this.setState({
        [`${fieldName}Error`]: errorMessage,
      });
      return;
    }

    const groupInfo = GroupCategory[fieldName];
    const filesWithMetadata = accepted.map((file) => ({
      id: uuidv4(),
      name: file.name,
      size: file.size,
      type: file.type,
      file,
      groupCategoryId: groupInfo.id,
      groupCategoryName: groupInfo.name,
      fieldName,
    }));
    this.getUploadFile(filesWithMetadata);
  };

  removeUploadedImage = (index, fieldName) => {
    const updated = [...this.state[fieldName]];
    updated.splice(index, 1);
    this.setState({ [fieldName]: updated });
  };

  handleVideoChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const allowedTypes = [
      "video/mp4",
      "video/webm",
      "video/quicktime",
      "video/hevc",
    ];
    const isAcceptedType = allowedTypes.includes(file.type);
    const isValidSize = file.size <= 100 * 1024 * 1024;

    if (!isAcceptedType) {
      this.setState({
        videoError: "Only MP4, WebM, MOV, and HEVC formats are allowed.",
        videoFile: null,
        videoPreviewUrl: "",
      });
      return;
    }

    if (!isValidSize) {
      this.setState({
        videoError: "Video must be under 100MB.",
        videoFile: null,
        videoPreviewUrl: "",
      });
      return;
    }

    const previewUrl = URL.createObjectURL(file);

    const videoWithMetadata = {
      file,
      id: uuidv4(),
      name: file.name,
      size: file.size,
      type: file.type,
      groupCategoryId: 2,
      groupCategoryName: "Video",
      fieldName: "videoFile",
    };

    this.setState(
      {
        videoFile: videoWithMetadata,
        videoPreviewUrl: previewUrl,
        videoError: "",
      },
      () => {
        this.getVideoUploadFile(videoWithMetadata);
      },
    );
  };

  getVideoUploadFile = async (fileObj) => {
    const fieldName = "videoFile";
    this.setState({ loading: true });

    try {
      const uploaded = await this.uploadFileDirectly(fileObj);

      this.setState({
        videoFile: uploaded,
        videoError: "",
        loading: false,
      });
    } catch (error) {
      this.setState({
        videoError: "Video upload failed",
        loading: false,
      });
    }
  };

  handleDeleteVideo = () => {
    const { videoFile, deletedFiles } = this.state;
    if (videoFile) {
      deletedFiles.push({
        Id: videoFile.uploadedFileId || videoFile.id,
        GroupName: 2,
      });
    }

    this.setState({
      videoFile: null,
      videoPreviewUrl: null,
      videoError: "",
      deletedFiles,
    });

    if (this.videoInputRef) {
      this.videoInputRef.value = "";
    }
  };

  handleSerialImageChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const allowedTypes = [
      "image/png",
      "image/jpeg",
      "image/jpg",
      "image/svg+xml",
      "image/heic",
      "image/heif",
      "image/webp",
    ];
    const allowedExtensions = [
      ".png",
      ".jpg",
      ".jpeg",
      ".svg",
      ".heic",
      ".heif",
      ".webp",
    ];
    const fileExtension = file.name
      .substring(file.name.lastIndexOf("."))
      .toLowerCase();
    const isAcceptedType =
      allowedTypes.includes(file.type) ||
      allowedExtensions.includes(fileExtension);
    const isValidSize = file.size <= 100 * 1024 * 1024;

    if (!isAcceptedType) {
      this.setState({
        serialImageError:
          "Only PNG, JPG, JPEG, SVG, HEIC, HEIF, and WEBP formats are allowed.",
        serialImage: null,
        serialImagePreviewUrl: "",
      });
      return;
    }

    if (!isValidSize) {
      this.setState({
        serialImageError: "Image must be under 100MB.",
        serialImage: null,
        serialImagePreviewUrl: "",
      });
      return;
    }

    let processedFile = file;

    if (fileExtension === ".heic" || fileExtension === ".heif") {
      try {
        const convertedBlob = await heic2any({
          blob: file,
          toType: "image/jpeg",
          quality: 0.8,
        });
        const newFileName = `${file.name.split(".")[0]}.jpeg`;
        processedFile = new File([convertedBlob], newFileName, {
          type: "image/jpeg",
          lastModified: file.lastModified,
        });
      } catch (error) {
        console.error("HEIC conversion failed:", error);
        this.setState({
          serialImageError: "Failed to convert HEIC/HEIF image.",
          serialImage: null,
          serialImagePreviewUrl: "",
        });
        return;
      }
    }

    const previewUrl = URL.createObjectURL(processedFile);

    const imageWithMetadata = {
      file: processedFile,
      id: uuidv4(),
      name: processedFile.name,
      size: processedFile.size,
      type: processedFile.type,
      groupCategoryId: 8,
      groupCategoryName: "SerialImage",
      fieldName: "serialImage",
    };

    this.setState(
      {
        serialImage: imageWithMetadata,
        serialImagePreviewUrl: previewUrl,
        serialImageError: "",
      },
      () => {
        this.getSerialImageUploadFile(imageWithMetadata);
      },
    );
  };

  getSerialImageUploadFile = async (fileObj) => {
    this.setState({ loading: true });

    try {
      const uploaded = await this.uploadFileDirectly(fileObj);

      this.setState({
        serialImage: uploaded,
        serialImageError: "",
        loading: false,
      });
    } catch (error) {
      this.setState({
        serialImageError: "Image upload failed",
        loading: false,
      });
    }
  };

  handleDeleteSerialImage = () => {
    const { serialImage, deletedFiles } = this.state;
    if (serialImage) {
      deletedFiles.push({
        Id: serialImage.uploadedFileId || serialImage.id,
        GroupName: 8,
      });
    }

    this.setState({
      serialImage: null,
      serialImagePreviewUrl: null,
      serialImageError: "",
      deletedFiles,
    });

    if (this.serialImageInputRef) {
      this.serialImageInputRef.value = "";
    }
  };

  handlePreviewFile = (file) => {
    const fileUrl = file.file
      ? URL.createObjectURL(file.file)
      : file.url || file.textAndUrl;
    const fileName =
      file.name || file.fileName || (file.file && file.file.name);
    const fileExt = fileName ? fileName.split(".").pop().toLowerCase() : "";

    this.setState({
      previewModalOpen: true,
      previewContent: { url: fileUrl, fileName, type: fileExt },
    });
  };

  closePreview = () => {
    this.setState({ previewModalOpen: false, previewContent: null });
  };

  renderPreviewModal = () => {
    const { previewModalOpen, previewContent } = this.state;
    if (!previewContent) return null;

    const fileExt = previewContent.type;
    const imageFiles = ["jpg", "jpeg", "png", "gif", "svg"];
    const videoFiles = ["mp4", "webm", "mov", "avi"];
    const officeFiles = ["doc", "docx", "xls", "xlsx", "ppt", "pptx"];

      const renderPreview = () => {
        if (imageFiles.includes(fileExt)) {
          return (
            <div className="preview-image-wrapper" style={{ width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
              <img
                src={previewContent.url}
                alt={previewContent.fileName}
                style={{ maxWidth: "100%", maxHeight: "80vh", objectFit: "contain" }}
              />
            </div>
          );
        }
      if (videoFiles.includes(fileExt)) {
        return (
          <video controls style={{ maxWidth: "100%", maxHeight: "80vh" }}>
            <source src={previewContent.url} type={`video/${fileExt}`} />
            Your browser does not support the video tag.
          </video>
        );
      }
      if (fileExt === "pdf" || fileExt === "txt") {
        return (
          <iframe
            src={previewContent.url}
            title={previewContent.fileName}
            style={{ width: "100%", height: "70vh", border: "none" }}
          />
        );
      }
      if (officeFiles.includes(fileExt)) {
        const isBlob = previewContent.url.startsWith("blob:");
        if (isBlob) {
          return (
            <div style={{ padding: "20px", textAlign: "center" }}>
              <p>Office document preview is not available for local files.</p>
              <button
                onClick={() => window.open(previewContent.url, "_blank")}
                className="btn btn-primary"
              >
                Download File
              </button>
            </div>
          );
        }
        return (
          <iframe
            src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
              previewContent.url,
            )}`}
            style={{ width: "100%", height: "70vh", border: "none" }}
            title={previewContent.fileName}
          />
        );
      }
      return (
        <div style={{ padding: "20px" }}>
          <p>Preview not available.</p>
          <button
            onClick={() => window.open(previewContent.url, "_blank")}
            className="btn btn-primary"
          >
            Open in New Tab
          </button>
        </div>
      );
    };

    return (
      <Modal
        show={previewModalOpen}
        onHide={this.closePreview}
        centered
        className="custom-preview-modal"
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>{previewContent.fileName}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: "0", display: "flex", justifyContent: "center", alignItems: "center" }}>
          {renderPreview()}
        </Modal.Body>
      </Modal>
    );
  };

  renderFileTypeIcon = (item) => {
    if (!item) return other;

    const extWord = ["doc", "docx"];
    const extExcel = ["xls", "xlsx"];
    const extPpt = ["ppt", "pptx"];
    const extImage = ["jpg", "jpeg", "png", "gif", "svg", "webp"];
    const extVideo = ["mp4", "m4v", "mid", "mkv", "webm", "mov", "avi", "wmv"];

    // Try to get filename from various sources
    let fileName = item.fileName || item.name;

    // If no fileName, try to extract from URL
    if (!fileName && (item.textAndUrl || item.url)) {
      const urlString = item.textAndUrl || item.url;
      try {
        // Extract filename from URL path
        const urlPath = urlString.split("?")[0]; // Remove query params
        fileName = urlPath.split("/").pop(); // Get last segment
      } catch (e) {
        fileName = null;
      }
    }

    if (!fileName) return other;

    const ext = fileName.split(".").pop().toLowerCase();

    if (extWord.includes(ext)) {
      return word;
    } else if (extExcel.includes(ext)) {
      return excel;
    } else if (extPpt.includes(ext)) {
      return ppt;
    } else if (extVideo.includes(ext)) {
      return video;
    } else if (ext === "pdf") {
      return pdf;
    } else if (extImage.includes(ext)) {
      return (
        item.thumbnailUrl ||
        item.url ||
        item.textAndUrl ||
        (item.file ? URL.createObjectURL(item.file) : null) ||
        other
      );
    } else {
      return other;
    }
  };

  handleDragOver = (e) => {
    e.preventDefault();
    this.setState({ isDragging: true });
  };

  handleDragLeave = () => {
    this.setState({ isDragging: false });
  };

  handleDrop = (e) => {
    e.preventDefault();
    this.setState({ isDragging: false });

    const files = Array.from(e.dataTransfer.files);

    const accepted = [];
    const rejected = [];

    files.forEach((file) => {
      if (
        ["application/pdf", "image/png", "image/jpg", "image/jpeg"].includes(
          file.type,
        )
      ) {
        accepted.push(file);
      } else {
        rejected.push(file);
      }
    });

    if (this.props.onDrop) {
      this.props.onDrop(accepted, rejected);
    }
  };

  onFetchListCategory = () => {
    this.props.dispatch({
      type: ProjectActionType.GET_LIST_CATEGORY_DROPDOWN_ASYNC,
      params: {
        projectId: this.props.projectId,
      },
      callback: (data) => {
        const formattedCategories = data.map((category) => ({
          text: category.name,
          value: category.name,
          id: category.id,
        }));
        this.setState({
          formattedCategories,
        });
      },
    });
  };

  handleDeleteUploadedImage = (index, fieldName) => {
    const currentFiles = [...this.state[fieldName]];
    const removedFile = currentFiles[index];
    const updated = [...currentFiles];
    updated.splice(index, 1);
    const deletedFiles = [...this.state.deletedFiles];
    if (removedFile) {
      const fileId = removedFile.uploadedFileId || removedFile.id;
      const groupName = GroupCategory[fieldName] && GroupCategory[fieldName].id;
      if (fileId) {
        deletedFiles.push({
          Id: fileId,
          GroupName: groupName,
        });
      }
    }
    this.setState({
      [fieldName]: updated,
      deletedFiles,
    });
    if (this.fileInput) {
      this.fileInput.value = "";
    }
    if (this.userManualInput) {
      this.userManualInput.value = "";
    }
    if (this.registrationInput) {
      this.registrationInput.value = "";
    }
    if (this.limitedWarrantyInput) {
      this.limitedWarrantyInput.value = "";
    }
    if (this.receiptsInput) {
      this.receiptsInput.value = "";
    }
    if (this.serviceContractOthersInput) {
      this.serviceContractOthersInput.value = "";
    }
  };

  handleFileChange = (e, fieldName) => {
    const selectedFiles = Array.from(e.target.files);

    if (selectedFiles.length === 0) return;

    const current = this.state[fieldName] || [];

    if (selectedFiles.length + current.length > 1) {
      this.setState({
        profileImagesError: "You are allowed to upload a single file only.",
      });
      return;
    }

    const allowedTypes = [
      "image/png",
      "image/jpg",
      "image/jpeg",
      "image/svg+xml",
      "image/webp",
    ];

    const accepted = selectedFiles.filter((file) => {
      const isAcceptedType = allowedTypes.includes(file.type);
      const isValidSize = file.size <= 100 * 1024 * 1024;
      return isAcceptedType && isValidSize;
    });

    if (accepted.length !== selectedFiles.length) {
      this.setState({
        profileImagesError:
          "Each file must be under 100MB and in SVG, PNG, JPG, JPEG, WEBP format.",
      });
      return;
    }

    const filesWithMetadata = accepted.map((file) => ({
      id: uuidv4(),
      name: file.name,
      size: file.size,
      type: file.type,
      file,
      groupCategoryId: 1,
      groupCategoryName: "Image",
      fieldName,
    }));

    this.getUploadFile(filesWithMetadata);
  };
  onSubmit = () => {
    const {
      itemName,
      itemCategory,
      generalDescription,
      mfgName,
      model,
      serial,
      serialImage,
      locationInHome,
      purchaseDate,
      price,
      typeOfPurchase,
      registration,
      registrationImages,
      userCareManual,
      userCareManualImages,
      limitedWarranty,
      limitedWarrantyImages,
      receiptsImages,
      serviceContractOthersImages,
      warrantyStart,
      warrantyEnd,
      videoFile,
      profileImages,
      smartApp,
      showRegistrationTextField,
      showuserCareManualTextField,
      showLimitedWarrantyTextField,
      deletedFiles,
      appName,
      androidURL,
      iosURL,
    } = this.state;
    console.log("Submitting with state:", this.state);
    if ((androidURL || iosURL) && !appName) {
      this.setState({
        androidURL: "",
        iosURL: "",
        appError: "",
      });
    } else {
      this.setState({ appError: "" });
    }

    let allFiles = [].concat(
      serialImage ? [serialImage] : [],
      registrationImages || [],
      userCareManualImages || [],
      limitedWarrantyImages || [],
      receiptsImages || [],
      serviceContractOthersImages || [],
      videoFile ? [videoFile] : [],
      profileImages || [],
    );

    const fileIds = allFiles
      .map((file) => file.uploadedFileId || file.fileId || file.id)
      .filter((id) => !!id);

    const normalizedDeletedFiles = (deletedFiles || []).map((item) => ({
      Id: item.Id || item.uploadedFileId || item.id,
      GroupName: item.GroupName || item.groupCategoryId || 0,
    }));

    const requestModel = {
      Id: this.props.itemDetails.id,
      CategoryId: itemCategory && itemCategory.id ? itemCategory.id : "",
      LotId: this.props.projectId,
      Name: itemName,
      Description: generalDescription,
      MFGName: mfgName,
      ModelNo: model,
      SerialNo: serial,
      LocationInHome: locationInHome,
      Price: parseFloat(price) || 0,
      PurchaseDate: purchaseDate ? new Date(purchaseDate).toISOString() : null,
      TypeofPurchase:
        typeOfPurchase && typeOfPurchase.value ? typeOfPurchase.value : "",
      SmartAppId: smartApp ? smartApp : null,
      WarrantyStartDate: warrantyStart
        ? new Date(warrantyStart).toISOString()
        : null,
      WarrantyEndDate: warrantyEnd ? new Date(warrantyEnd).toISOString() : null,
      RegistrationText: registration,
      UseCareManualText: userCareManual,
      LimitedWarrantyText: limitedWarranty,
      FileIds: fileIds,
      DeletedFileIds: normalizedDeletedFiles,
      AppName: appName && appName ? appName : "",
      AndroidUrl: androidURL && androidURL ? androidURL : "",
      IosUrl: iosURL && iosURL ? iosURL : "",
    };

    if (appName && !androidURL && !iosURL) {
      this.setState({
        appError:
          "Please enter either the Android URL or the iOS URL for the app",
      });
      return;
    }

    this.props.dispatch({
      type: ProjectActionType.UPDATE_BUILDER_INVENTORY_ITEM,
      params: {
        headers: {
          url: AppSettings.CURRENT_SITE_URI,
        },
        data: requestModel,
      },
      callback: (data) => {
        this.props.onChangeMode(true);
        this.props.closeModal();
      },
    });
  };

  render() {
    const {
      isDragging,
      showBasicDetails,
      showItemDetail,
      videoFile,
      showLinkDocument,
      showReceiptsotherDocs,
      loading,
      showOtherDocs,
    } = this.state;
    const { isOpen, closeModal, accept } = this.props;

    return (
      <React.Fragment>
        <Modal
          show={isOpen}
          onHide={closeModal}
          backdrop="static"
          dialogClassName="slide-in-modal"
          className="modal-right"
        >
          <Modal.Header className="modal-header-profile">
            <div className="modal-header">
              <i
                className="fa fa-chevron-left arrow-btn"
                aria-hidden="true"
                onClick={closeModal}
              ></i>
              <Modal.Title className="modal-title-custom">
                Edit Item
              </Modal.Title>
            </div>
          </Modal.Header>

          <Modal.Body className="modal-body-add-doc scrollable-modal-body">
            {this.state.showAIScan ? (
              <AIScanViewEdit
                onPrefill={this.handleAIScanPrefill}
                initialStep={2}
                onCancel={() => this.setState({ showAIScan: false })}
                initialData={{
                  productName: this.state.itemName || "",
                  manufacturer: this.state.mfgName || "",
                  modelNumber: this.state.model || "",
                  serialNumber: this.state.serial || "",
                }}
                onQuickSave={(data) => {
                  this.setState({
                    itemName: data.productName || "",
                    mfgName: data.manufacturer || "",
                    model: data.modelNumber || "",
                    serial: data.serialNumber || "",
                  });
                }}
                onFindDetails={(payload, callback) => {
                  this.props.dispatch({
                    type: ProjectActionType.AI_SCAN_ITEM_IMAGE_ASYNC,
                    params: payload,
                    callback,
                  });
                }}
                onFindItemDetails={(payload, callback) => {
                  this.props.dispatch({
                    type: ProjectActionType.AI_FIND_ITEM_DETAIL_ASYNC,
                    params: payload,
                    callback,
                  });
                }}
                onScanReceipt={(payload, callback) => {
                  this.props.dispatch({
                    type: ProjectActionType.AI_SCAN_RECEIPT_ASYNC,
                    params: payload,
                    callback,
                  });
                }}
              />
            ) : (
              <React.Fragment>
                <div className="image-upload-section">
                  {this.state.profileImages.length > 0 ? (
                    <div style={{ width: "100%" }}>
                      {this.state.profileImages.map((doc, index) => {
                        const fileTypeIcon = this.renderFileTypeIcon(doc);

                        return (
                          <div key={index} className="item-card-content">
                            <div
                              className="item-card"
                              onClick={() => this.handlePreviewFile(doc)}
                              style={{ cursor: "pointer" }}
                            >
                              {/* Left: icon */}
                              <div className="left-section">
                                <img
                                  src={fileTypeIcon}
                                  alt="file icon"
                                  className="doc-icon"
                                />
                              </div>

                              {/* Middle: file name */}
                              <div
                                className="middle-section"
                                title={doc.name || doc.fileName}
                              >
                                <div className="doc-title">
                                  {getTruncatedFilename(doc)}
                                </div>
                              </div>

                              {/* Right: delete icon */}
                              <div className="right-section">
                                <i
                                  className="fa fa-trash"
                                  style={{
                                    color: "red",
                                    cursor: "pointer",
                                    marginLeft: "10px",
                                    fontSize: "20px",
                                  }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    this.handleDeleteUploadedImage(
                                      index,
                                      "profileImages",
                                    );
                                  }}
                                  title="Delete image"
                                ></i>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  ) : (
                    this.props.isEdit &&
                    this.props.selectedCategory &&
                    this.props.selectedCategory.imageUrl && (
                      <img
                        className="doc-img-upload"
                        onClick={() => this.fileInput.click()}
                        src={this.props.selectedCategory.imageUrl}
                        alt="Existing Preview"
                      />
                    )
                  )}

                  <div
                    className={`modal-dropzone ${isDragging ? "dragging" : ""}`}
                    onDragOver={this.handleDragOver}
                    onDragLeave={this.handleDragLeave}
                    onDrop={this.handleDrop}
                  >
                    <input
                      type="file"
                      accept=".pdf, .doc, .docx, .xls, .xlsx, .txt, .jpg, .jpeg, .png, .heic, .gif, .ppt, .pptx, .numbers, .pages, .tiff, .webp"
                      multiple
                      onChange={(ref) =>
                        this.handleFileChange(ref, "profileImages")
                      }
                      style={{ display: "none" }}
                      ref={(ref) => (this.fileInput = ref)}
                    />
                    <button
                      type="button"
                      className="upload-document-btn"
                      onClick={() => this.fileInput.click()}
                    >
                      <i class="fa fa-picture-o" aria-hidden="true"></i> Upload
                      File
                    </button>
                    <button
                      className="save-doc-btn1"
                      type="submit"
                      onClick={(e) => {
                        e.preventDefault();
                        this.setState({ showAIScan: true });
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-sparkles-icon lucide-sparkles"
                        style={{ marginRight: "5px", verticalAlign: "middle" }}
                      >
                        <path d="M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z" />
                        <path d="M20 2v4" />
                        <path d="M22 4h-4" />
                        <circle cx="4" cy="20" r="2" />
                      </svg>
                      Update Details Using AI
                    </button>
                  </div>
                </div>

                {this.state.profileImagesError && (
                  <div
                    className="error-message"
                    style={{ color: "red", marginBottom: "10px" }}
                  >
                    {this.state.profileImagesError}
                  </div>
                )}

                <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                  <Row className="clearfix">
                    <Col sm={12}>
                      <Tab.Content animation className="add-inventory-item">
                        <Tab.Pane eventKey="first">
                          <Form
                            ref={(c) => {
                              this.form = c;
                            }}
                            onSubmit={this.onSubmit.bind(this)}
                          >
                            {/* Basic Detail panel */}
                            <Panel>
                              <Panel.Heading
                                onClick={() =>
                                  this.togglePanel("showBasicDetails")
                                }
                              >
                                <div className="accordion-header">
                                  <span>
                                    <span
                                      className={`glyphicon arrow-icon ${
                                        showBasicDetails
                                          ? "glyphicon-chevron-up"
                                          : "glyphicon-chevron-down"
                                      }`}
                                    ></span>{" "}
                                    <span className="lot-titles">
                                      Basic Details
                                    </span>
                                  </span>
                                </div>
                              </Panel.Heading>
                              {showBasicDetails && (
                                <Panel.Body>
                                  <div className="box-form-body">
                                    <div className="form-group">
                                      <label>
                                        Name
                                        <strong className="text-danger">
                                          *
                                        </strong>
                                      </label>
                                      <input
                                        type="text"
                                        name="itemName"
                                        value={this.state.itemName}
                                        onChange={this.handleInputChange}
                                        placeholder="Enter name"
                                        className="input-field"
                                      />
                                      {this.state.error && (
                                        <p className="error-message">
                                          {this.state.error}
                                        </p>
                                      )}
                                    </div>
                                    <div className="form-group">
                                      <label>
                                        Category
                                        <strong className="text-danger">
                                          *
                                        </strong>
                                      </label>

                                      <Dropdown
                                        onChange={(ref) => {
                                          this.onSelectChange(
                                            ref,
                                            "itemCategory",
                                          );
                                        }}
                                        className="filestring-dropdown filter-dropdown"
                                        options={this.state.formattedCategories}
                                        optionLabel="text"
                                        onRemote={this.onFetchListCategory}
                                        value={this.state.itemCategory}
                                        showClear={true}
                                        name="itemCategory"
                                        placeholder="-- Please select"
                                        style={{
                                          width: "100%",
                                          display: "inline-block",
                                        }}
                                      />
                                    </div>
                                    <div
                                      className="form-group"
                                      style={{ margin: "-20px 0px" }}
                                    >
                                      <label>General Description</label>
                                      <textarea
                                        rows={7}
                                        name="generalDescription"
                                        ref="generalDescription"
                                        placeholder="General description"
                                        className="form-control"
                                        maxLength="250"
                                        value={this.state.generalDescription}
                                        onChange={(e) =>
                                          this.setState({
                                            generalDescription: e.target.value,
                                          })
                                        }
                                      />
                                    </div>
                                  </div>
                                </Panel.Body>
                              )}
                            </Panel>
                            {/* Item Detail Panel */}
                            <Panel>
                              <Panel.Heading
                                onClick={() =>
                                  this.togglePanel("showItemDetail")
                                }
                              >
                                <div className="accordion-header">
                                  <span>
                                    <span
                                      className={`glyphicon arrow-icon ${
                                        showItemDetail
                                          ? "glyphicon-chevron-up"
                                          : "glyphicon-chevron-down"
                                      }`}
                                    ></span>
                                    <span className="lot-titles">
                                      Item Details
                                    </span>
                                  </span>
                                </div>
                              </Panel.Heading>
                              {showItemDetail && (
                                <Panel.Body>
                                  <div className="box-form-body">
                                    <div className="form-group">
                                      <label>MFG Name / Vendor</label>
                                      <input
                                        type="text"
                                        name="mfgName"
                                        value={this.state.mfgName}
                                        onChange={this.handleInputChange}
                                        placeholder="Enter name / vendor"
                                        className="input-field"
                                        max="50"
                                        maxLength="50"
                                      />
                                    </div>
                                    <div className="form-group">
                                      <label>Model #</label>
                                      <input
                                        type="text"
                                        name="model"
                                        value={this.state.model}
                                        onChange={this.handleInputChange}
                                        placeholder="Enter model"
                                        className="input-field"
                                        max="50"
                                        maxLength="50"
                                      />
                                    </div>{" "}
                                    <div className="form-group">
                                      <label>Serial #</label>
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "space-between",
                                          gap: "10px",
                                          marginBottom: "20px",
                                        }}
                                      >
                                        <input
                                          type="text"
                                          name="serial"
                                          value={this.state.serial}
                                          onChange={this.handleInputChange}
                                          placeholder="Enter serial"
                                          className="input-field"
                                          max="50"
                                          maxLength="50"
                                          style={{ flex: 1, width: "210%" }}
                                        />
                                        <span>
                                          <i
                                            className="fa fa-file-text-o"
                                            aria-hidden="true"
                                            style={{
                                              fontSize: "24px",
                                              cursor: "pointer",
                                            }}
                                            onClick={() => {
                                              if (this.serialImageInputRef)
                                                this.serialImageInputRef.click();
                                            }}
                                          ></i>
                                          <input
                                            type="file"
                                            id="serial-image-file"
                                            name="serialImage"
                                            accept="image/png, image/jpeg, image/jpg, image/webp, .webp"
                                            style={{ display: "none" }}
                                            ref={(ref) =>
                                              (this.serialImageInputRef = ref)
                                            }
                                            onChange={
                                              this.handleSerialImageChange
                                            }
                                          />
                                        </span>
                                      </div>
                                      <div className="text-danger mt-2">
                                        {this.state.serialImageError}
                                      </div>
                                      {this.state.serialImagePreviewUrl && (
                                        <div id="preview" className="mt-3">
                                          <div className="item-card-content">
                                            <div className="item-card">
                                              <div className="left-section">
                                                <img
                                                  src={
                                                    this.state
                                                      .serialImagePreviewUrl
                                                  }
                                                  alt="serial preview"
                                                  className="doc-icon"
                                                />
                                              </div>
                                              <div
                                                className="middle-section"
                                                title={
                                                  this.state.serialImage
                                                    .fileName ||
                                                  this.state.serialImage.name
                                                }
                                              >
                                                <div className="doc-title">
                                                  {this.state.serialImage
                                                    .fileName ||
                                                    this.state.serialImage.name}
                                                </div>
                                              </div>
                                              <div
                                                style={{
                                                  textAlign: "right",
                                                }}
                                              >
                                                <button
                                                  type="button"
                                                  className="btn btn-sm"
                                                  style={{ border: "none" }}
                                                  onClick={
                                                    this.handleDeleteSerialImage
                                                  }
                                                >
                                                  <i
                                                    className="fa fa-trash"
                                                    style={{
                                                      color: "red",
                                                      cursor: "pointer",
                                                      marginLeft: "10px",
                                                      fontSize: "20px",
                                                    }}
                                                  ></i>
                                                </button>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                    </div>{" "}
                                    <div className="form-group">
                                      <label>
                                        Location in Home
                                        <strong className="text-danger">
                                          *
                                        </strong>
                                      </label>
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "space-between",
                                          gap: "10px",
                                          marginBottom: "20px",
                                        }}
                                      >
                                        <Input
                                          type="text"
                                          name="locationInHome"
                                          value={this.state.locationInHome}
                                          onChange={this.handleInputChange}
                                          placeholder="Enter location in home"
                                          className="input-field"
                                          max="50"
                                          maxLength="50"
                                          style={{ flex: 1, width: "210%" }}
                                        />
                                        <span>
                                          <i
                                            className="fa fa-file-video-o"
                                            aria-hidden="true"
                                            style={{
                                              fontSize: "24px",
                                              cursor: "pointer",
                                            }}
                                            onClick={() =>
                                              this.videoInputRef &&
                                              this.videoInputRef.click()
                                            }
                                          ></i>
                                          <input
                                            type="file"
                                            id="video-file"
                                            name="video"
                                            accept="video/mp4, video/webm, video/quicktime, video/hevc"
                                            style={{ display: "none" }}
                                            ref={(ref) =>
                                              (this.videoInputRef = ref)
                                            }
                                            onChange={this.handleVideoChange}
                                          />
                                        </span>
                                      </div>
                                      <div className="text-danger mt-2">
                                        {this.state.videoError}
                                      </div>
                                      {this.state.videoPreviewUrl && (
                                        <div id="preview" className="mt-3">
                                          <div className="item-card-content">
                                            <div className="item-card">
                                              {/* Left: icon */}
                                              <div className="left-section">
                                                <img
                                                  src={this.renderFileTypeIcon(
                                                    videoFile,
                                                  )}
                                                  alt="file icon"
                                                  className="doc-icon"
                                                />
                                              </div>

                                              <div
                                                className="middle-section"
                                                title={
                                                  videoFile.fileName ||
                                                  videoFile.file.name
                                                }
                                              >
                                                <div className="doc-title">
                                                  {getTruncatedFilename(
                                                    videoFile,
                                                  )}
                                                </div>
                                              </div>
                                              <div
                                                style={{
                                                  textAlign: "right",
                                                }}
                                              >
                                                <button
                                                  type="button"
                                                  className="btn btn-sm"
                                                  style={{ border: "none" }}
                                                  onClick={
                                                    this.handleDeleteVideo
                                                  }
                                                >
                                                  <i
                                                    className="fa fa-trash"
                                                    style={{
                                                      color: "red",
                                                      cursor: "pointer",
                                                      marginLeft: "10px",
                                                      fontSize: "20px",
                                                    }}
                                                  ></i>
                                                </button>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                    <div className="form-group ">
                                      <div>
                                        <label>Purchase Date</label>
                                        <Datetime
                                          name="purchaseDate"
                                          inputProps={{
                                            placeholder: "mm/dd/yyyy",
                                          }}
                                          timeFormat={false}
                                          value={
                                            this.state.purchaseDate
                                              ? Moment(
                                                  this.state.purchaseDate,
                                                ).format("MM/DD/YYYY")
                                              : null
                                          }
                                          onChange={this.onChangepurchaseDate}
                                          closeOnSelect={true}
                                          style={{
                                            width: "100%",
                                            display: "inline-block",
                                          }}
                                        />
                                      </div>
                                    </div>{" "}
                                    <div className="form-group">
                                      <label>Price</label>
                                      <div
                                        className="input-group"
                                        style={{
                                          width: "100%",
                                        }}
                                      >
                                        <span
                                          className="input-group-addon"
                                          style={{ fontSize: "18px" }}
                                        >
                                          $
                                        </span>

                                        <Input
                                          type="number"
                                          name="price"
                                          value={this.state.price}
                                          onChange={this.handleInputChange}
                                          placeholder="Enter price"
                                          className="input-field form-control"
                                          min="0"
                                          step="0.01"
                                          style={{
                                            border: "1px solid #dbeafe",
                                          }}
                                        />
                                      </div>
                                    </div>
                                    <div className="form-group">
                                      <label>
                                        Type of Purchase
                                        <strong className="text-danger">
                                          *
                                        </strong>
                                      </label>
                                      <Dropdown
                                        onChange={(ref) => {
                                          this.onSelectChange(
                                            ref,
                                            "typeOfPurchase",
                                          );
                                        }}
                                        filter={true}
                                        className="filestring-dropdown filter-dropdown"
                                        options={this.state.typeOfPurchaseList}
                                        optionLabel="text"
                                        value={this.state.typeOfPurchase}
                                        showClear={true}
                                        name="room"
                                        placeholder="-- Please select"
                                        ref={(ref) => {
                                          this.typeOfPurchase = ref;
                                        }}
                                        style={{ width: "100%" }}
                                      />{" "}
                                    </div>
                                  </div>
                                </Panel.Body>
                              )}
                            </Panel>

                            {/* Link and  Documents */}
                            <Panel>
                              <Panel.Heading
                                onClick={() =>
                                  this.togglePanel("showLinkDocument")
                                }
                              >
                                <div className="accordion-header">
                                  <span>
                                    <span
                                      className={`glyphicon arrow-icon ${
                                        showLinkDocument
                                          ? "glyphicon-chevron-up"
                                          : "glyphicon-chevron-down"
                                      }`}
                                    ></span>

                                    <span className="lot-titles">
                                      Link & Documents
                                    </span>
                                  </span>
                                </div>
                              </Panel.Heading>
                              {showLinkDocument && (
                                <Panel.Body>
                                  {/* --- Registration --- */}
                                  <div className="form-group link-document-fields">
                                    <label>Registration</label>
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        gap: "10px",
                                        marginBottom: "20px",
                                      }}
                                    >
                                      <input
                                        type="text"
                                        name="registration"
                                        value={this.state.registration}
                                        onChange={this.handleInputChange}
                                        placeholder="Enter registration link"
                                        className="input-field"
                                        style={{ flex: 1, width: "210%" }}
                                      />
                                      <span>
                                        <i
                                          className="fa fa-file-text-o"
                                          aria-hidden="true"
                                          style={{
                                            fontSize: "24px",
                                            cursor: "pointer",
                                          }}
                                          onClick={() => {
                                            if (this.registrationInput)
                                              this.registrationInput.click();
                                          }}
                                        ></i>
                                        <input
                                          type="file"
                                          accept=".pdf, .doc, .docx, .xls, .xlsx, .txt, .jpg, .jpeg, .png, .heic, .gif, .ppt, .pptx, .numbers, .pages, .tiff, .webp"
                                          multiple
                                          onChange={(ref) => {
                                            this.handleUploadImages(
                                              ref,
                                              "registrationImages",
                                            );
                                          }}
                                          style={{ display: "none" }}
                                          ref={(ref) =>
                                            (this.registrationInput = ref)
                                          }
                                        />
                                      </span>
                                    </div>
                                    {this.state.registrationImagesError && (
                                      <div
                                        style={{ color: "red", marginTop: 5 }}
                                      >
                                        {this.state.registrationImagesError}
                                      </div>
                                    )}
                                    {this.state.registrationImages.length >
                                      0 && (
                                      <div style={{ marginTop: "20px" }}>
                                        {this.state.registrationImages.map(
                                          (doc, index) => {
                                            const fileTypeIcon =
                                              this.renderFileTypeIcon(doc);

                                            return (
                                              <div
                                                key={index}
                                                className="item-card-content"
                                              >
                                                <div className="item-card">
                                                  <div className="left-section">
                                                    <img
                                                      src={fileTypeIcon}
                                                      alt="file icon"
                                                      className="doc-icon"
                                                    />
                                                  </div>
                                                  <div
                                                    className="middle-section"
                                                    title={
                                                      doc.name || doc.fileName
                                                    }
                                                  >
                                                    <div className="doc-title">
                                                      {getTruncatedFilename(
                                                        doc,
                                                      )}
                                                    </div>
                                                  </div>
                                                  <div className="right-section">
                                                    <i
                                                      className="fa fa-trash"
                                                      style={{
                                                        color: "red",
                                                        cursor: "pointer",
                                                        marginLeft: "10px",
                                                        fontSize: "20px",
                                                      }}
                                                      onClick={() =>
                                                        this.handleDeleteUploadedImage(
                                                          index,
                                                          "registrationImages",
                                                        )
                                                      }
                                                      title="Delete image"
                                                    ></i>
                                                  </div>
                                                </div>
                                              </div>
                                            );
                                          },
                                        )}
                                      </div>
                                    )}
                                  </div>
                                  {/*User & Care Manual  */}
                                  <div className="form-group link-document-fields">
                                    <label>User & Care Manual</label>
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        gap: "10px",
                                        marginBottom: "20px",
                                      }}
                                    >
                                      <input
                                        type="text"
                                        name="userCareManual"
                                        value={this.state.userCareManual}
                                        onChange={this.handleInputChange}
                                        placeholder="Enter user and care manual link"
                                        className="input-field"
                                        style={{ flex: 1, width: "210%" }}
                                      />
                                      <span>
                                        <i
                                          className="fa fa-file-text-o"
                                          aria-hidden="true"
                                          style={{
                                            fontSize: "24px",
                                            cursor: "pointer",
                                          }}
                                          onClick={() => {
                                            if (this.userManualInput)
                                              this.userManualInput.click();
                                          }}
                                        ></i>
                                        <input
                                          type="file"
                                          accept=".pdf, .doc, .docx, .xls, .xlsx, .txt, .jpg, .jpeg, .png, .heic, .gif, .ppt, .pptx, .numbers, .pages, .tiff, .webp"
                                          multiple
                                          onChange={(ref) => {
                                            this.handleUploadImages(
                                              ref,
                                              "userCareManualImages",
                                            );
                                          }}
                                          style={{ display: "none" }}
                                          ref={(ref) =>
                                            (this.userManualInput = ref)
                                          }
                                        />
                                      </span>
                                    </div>
                                    {this.state.userCareManualImagesError && (
                                      <div
                                        style={{ color: "red", marginTop: 5 }}
                                      >
                                        {this.state.userCareManualImagesError}
                                      </div>
                                    )}
                                    {this.state.userCareManualImages.length >
                                      0 && (
                                      <div style={{ marginTop: "20px" }}>
                                        {this.state.userCareManualImages.map(
                                          (doc, index) => {
                                            const fileTypeIcon =
                                              this.renderFileTypeIcon(doc);

                                            return (
                                              <div
                                                key={index}
                                                className="item-card-content"
                                              >
                                                <div className="item-card">
                                                  <div className="left-section">
                                                    <img
                                                      src={fileTypeIcon}
                                                      alt="file icon"
                                                      className="doc-icon"
                                                    />
                                                  </div>
                                                  <div
                                                    className="middle-section"
                                                    title={
                                                      doc.name || doc.fileName
                                                    }
                                                  >
                                                    <div className="doc-title">
                                                      {getTruncatedFilename(
                                                        doc,
                                                      )}
                                                    </div>
                                                  </div>
                                                  <div className="right-section">
                                                    <i
                                                      className="fa fa-trash"
                                                      style={{
                                                        color: "red",
                                                        cursor: "pointer",
                                                        marginLeft: "10px",
                                                        fontSize: "20px",
                                                      }}
                                                      onClick={() =>
                                                        this.handleDeleteUploadedImage(
                                                          index,
                                                          "userCareManualImages",
                                                        )
                                                      }
                                                      title="Delete image"
                                                    ></i>
                                                  </div>
                                                </div>
                                              </div>
                                            );
                                          },
                                        )}
                                      </div>
                                    )}
                                  </div>

                                  {/* --- Limited Warranty --- */}
                                  <div className="form-group link-document-fields">
                                    <label>Limited Warranty</label>
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        gap: "10px",
                                        marginBottom: "20px",
                                      }}
                                    >
                                      <input
                                        type="text"
                                        name="limitedWarranty"
                                        value={this.state.limitedWarranty}
                                        onChange={this.handleInputChange}
                                        placeholder="Enter limited warranty link"
                                        className="input-field"
                                        style={{ flex: 1, width: "210%" }}
                                      />
                                      <span>
                                        <i
                                          className="fa fa-file-text-o"
                                          aria-hidden="true"
                                          style={{
                                            fontSize: "24px",
                                            cursor: "pointer",
                                          }}
                                          onClick={() => {
                                            if (this.limitedWarrantyInput)
                                              this.limitedWarrantyInput.click();
                                          }}
                                        ></i>
                                        <input
                                          type="file"
                                          accept=".pdf, .doc, .docx, .xls, .xlsx, .txt, .jpg, .jpeg, .png, .heic, .gif, .ppt, .pptx, .numbers, .pages, .tiff, .webp"
                                          multiple
                                          onChange={(ref) => {
                                            this.handleUploadImages(
                                              ref,
                                              "limitedWarrantyImages",
                                            );
                                          }}
                                          style={{ display: "none" }}
                                          ref={(ref) =>
                                            (this.limitedWarrantyInput = ref)
                                          }
                                        />
                                      </span>
                                    </div>
                                    {this.state.limitedWarrantyImagesError && (
                                      <div
                                        style={{ color: "red", marginTop: 5 }}
                                      >
                                        {this.state.limitedWarrantyImagesError}
                                      </div>
                                    )}
                                    {this.state.limitedWarrantyImages.length >
                                      0 && (
                                      <div style={{ marginTop: "20px" }}>
                                        {this.state.limitedWarrantyImages.map(
                                          (doc, index) => {
                                            const fileTypeIcon =
                                              this.renderFileTypeIcon(doc);

                                            return (
                                              <div
                                                key={index}
                                                className="item-card-content"
                                              >
                                                <div className="item-card">
                                                  <div className="left-section">
                                                    <img
                                                      src={fileTypeIcon}
                                                      alt="file icon"
                                                      className="doc-icon"
                                                    />
                                                  </div>
                                                  <div
                                                    className="middle-section"
                                                    title={
                                                      doc.name || doc.fileName
                                                    }
                                                  >
                                                    <div className="doc-title">
                                                      {getTruncatedFilename(
                                                        doc,
                                                      )}
                                                    </div>
                                                  </div>
                                                  <div className="right-section">
                                                    <i
                                                      className="fa fa-trash"
                                                      style={{
                                                        color: "red",
                                                        cursor: "pointer",
                                                        marginLeft: "10px",
                                                        fontSize: "20px",
                                                      }}
                                                      onClick={() =>
                                                        this.handleDeleteUploadedImage(
                                                          index,
                                                          "limitedWarrantyImages",
                                                        )
                                                      }
                                                      title="Delete image"
                                                    ></i>
                                                  </div>
                                                </div>
                                              </div>
                                            );
                                          },
                                        )}
                                      </div>
                                    )}
                                  </div>

                                  <div className="form-group">
                                    <label>Warranty Start</label>
                                    <Datetime
                                      name="warrantyStart"
                                      inputProps={{
                                        placeholder: "mm/dd/yyyy",
                                      }}
                                      value={
                                        this.state.warrantyStart
                                          ? Moment(
                                              this.state.warrantyStart,
                                            ).format("MM/DD/YYYY")
                                          : null
                                      }
                                      timeFormat={false}
                                      onChange={this.onChangeWarrantyStart}
                                      closeOnSelect={true}
                                      style={{
                                        width: "100%",
                                        display: "inline-block",
                                      }}
                                    />
                                  </div>
                                  <div className="form-group">
                                    <label>Warranty End</label>

                                    <Datetime
                                      name="warrantyEnd"
                                      inputProps={{
                                        placeholder: "mm/dd/yyyy",
                                      }}
                                      timeFormat={false}
                                      value={
                                        this.state.warrantyEnd
                                          ? Moment(
                                              this.state.warrantyEnd,
                                            ).format("MM/DD/YYYY")
                                          : null
                                      }
                                      onChange={this.onChangewarrantyEnd}
                                      closeOnSelect={true}
                                      style={{
                                        width: "100%",
                                        display: "inline-block",
                                      }}
                                    />
                                    {this.state.warrantyError && (
                                      <div
                                        style={{ color: "red", marginTop: 5 }}
                                      >
                                        {this.state.warrantyError}
                                      </div>
                                    )}
                                  </div>
                                </Panel.Body>
                              )}
                            </Panel>

                            {/* Receipts and Other Docs */}
                            <Panel>
                              <Panel.Heading
                                onClick={() =>
                                  this.togglePanel("showReceiptsotherDocs")
                                }
                              >
                                <div className="accordion-header">
                                  <span>
                                    <span
                                      className={`glyphicon arrow-icon ${
                                        showReceiptsotherDocs
                                          ? "glyphicon-chevron-up"
                                          : "glyphicon-chevron-down"
                                      }`}
                                    ></span>

                                    <span className="lot-titles">
                                      Receipts & Other Docs
                                    </span>
                                  </span>
                                </div>
                              </Panel.Heading>
                              {showReceiptsotherDocs && (
                                <Panel.Body>
                                  <div>
                                    <label>Receipts</label>
                                    <div className="image-upload-section">
                                      <div
                                        className={`modal-dropzone ${
                                          isDragging ? "dragging" : ""
                                        }`}
                                        onDragOver={this.handleDragOver}
                                        onDragLeave={this.handleDragLeave}
                                        onDrop={this.handleDrop}
                                      >
                                        <input
                                          type="file"
                                          accept=".pdf, .doc, .docx, .xls, .xlsx, .txt, .jpg, .jpeg, .png, .heic, .gif, .ppt, .pptx, .numbers, .pages, .tiff, .webp"
                                          multiple
                                          onChange={(ref) => {
                                            this.handleUploadImages(
                                              ref,
                                              "receiptsImages",
                                            );
                                          }}
                                          style={{ display: "none" }}
                                          ref={(ref) =>
                                            (this.receiptsInput = ref)
                                          }
                                        />
                                        <button
                                          type="button"
                                          className="file-upload-btn"
                                          onClick={() =>
                                            this.receiptsInput.click()
                                          }
                                        >
                                          Upload Document
                                          <i
                                            class="fa fa-file-text-o"
                                            style={{ fontSize: "18px" }}
                                            aria-hidden="true"
                                          ></i>
                                        </button>
                                      </div>
                                    </div>
                                    {this.state.receiptsImagesError && (
                                      <div
                                        style={{ color: "red", marginTop: 5 }}
                                      >
                                        {this.state.receiptsImagesError}
                                      </div>
                                    )}
                                    <div style={{ marginTop: "20px" }}>
                                      {this.state.receiptsImages.map(
                                        (doc, index) => {
                                          const fileTypeIcon =
                                            this.renderFileTypeIcon(doc);

                                          return (
                                            <div
                                              key={index}
                                              className="item-card-content"
                                            >
                                              <div className="item-card">
                                                {/* Left: icon */}
                                                <div className="left-section">
                                                  <img
                                                    src={fileTypeIcon}
                                                    alt="file icon"
                                                    className="doc-icon"
                                                  />
                                                </div>
                                                {/* Middle: file name */}
                                                <div
                                                  className="middle-section"
                                                  title={
                                                    doc.name || doc.fileName
                                                  }
                                                >
                                                  <div className="doc-title">
                                                    {getTruncatedFilename(doc)}
                                                  </div>
                                                </div>
                                                {/* Right: delete icon */}
                                                <div className="right-section">
                                                  <i
                                                    className="fa fa-trash"
                                                    style={{
                                                      color: "red",
                                                      cursor: "pointer",
                                                      marginLeft: "10px",
                                                      fontSize: "20px",
                                                    }}
                                                    onClick={() =>
                                                      this.handleDeleteUploadedImage(
                                                        index,
                                                        "receiptsImages",
                                                      )
                                                    }
                                                    title="Delete image"
                                                  ></i>
                                                </div>
                                              </div>
                                            </div>
                                          );
                                        },
                                      )}
                                    </div>
                                  </div>

                                  <div>
                                    <label>Service Contract & Others</label>
                                    <div className="image-upload-section">
                                      <div
                                        className={`modal-dropzone ${
                                          isDragging ? "dragging" : ""
                                        }`}
                                        onDragOver={this.handleDragOver}
                                        onDragLeave={this.handleDragLeave}
                                        onDrop={this.handleDrop}
                                      >
                                        <input
                                          type="file"
                                          accept=".pdf, .doc, .docx, .xls, .xlsx, .txt, .jpg, .jpeg, .png, .heic, .gif, .ppt, .pptx, .numbers, .pages, .tiff, .webp"
                                          multiple
                                          onChange={(ref) => {
                                            this.handleUploadImages(
                                              ref,
                                              "serviceContractOthersImages",
                                            );
                                          }}
                                          style={{ display: "none" }}
                                          ref={(ref) =>
                                            (this.serviceContractOthersInput =
                                              ref)
                                          }
                                        />
                                        <button
                                          type="button"
                                          className="file-upload-btn"
                                          onClick={() =>
                                            this.serviceContractOthersInput.click()
                                          }
                                        >
                                          Upload Document
                                          <i
                                            class="fa fa-file-text-o"
                                            style={{ fontSize: "18px" }}
                                            aria-hidden="true"
                                          ></i>
                                        </button>
                                      </div>
                                    </div>
                                    {this.state
                                      .serviceContractOthersImagesError && (
                                      <div
                                        style={{ color: "red", marginTop: 5 }}
                                      >
                                        {
                                          this.state
                                            .serviceContractOthersImagesError
                                        }
                                      </div>
                                    )}
                                    <div style={{ marginTop: "20px" }}>
                                      {this.state.serviceContractOthersImages.map(
                                        (doc, index) => {
                                          const fileTypeIcon =
                                            this.renderFileTypeIcon(doc);

                                          return (
                                            <div
                                              key={index}
                                              className="item-card-content"
                                            >
                                              <div
                                                className="item-card"
                                                onClick={() => this.handlePreviewFile(doc)}
                                                style={{ cursor: "pointer" }}
                                              >
                                                {/* Left: icon */}
                                                <div className="left-section">
                                                  <img
                                                    src={fileTypeIcon}
                                                    alt="file icon"
                                                    className="doc-icon"
                                                  />
                                                </div>
                                                {/* Middle: file name */}
                                                <div
                                                  className="middle-section"
                                                  title={
                                                    doc.name || doc.fileName
                                                  }
                                                >
                                                  <div className="doc-title">
                                                    {getTruncatedFilename(doc)}
                                                  </div>
                                                </div>
                                                {/* Right: delete icon */}
                                                <div className="right-section">
                                                  <i
                                                    className="fa fa-trash"
                                                    style={{
                                                      color: "red",
                                                      cursor: "pointer",
                                                      marginLeft: "10px",
                                                      fontSize: "20px",
                                                    }}
                                                    onClick={(e) => {
                                                      e.stopPropagation();
                                                      this.handleDeleteUploadedImage(
                                                        index,
                                                        "serviceContractOthersImages",
                                                      );
                                                    }}
                                                    title="Delete image"
                                                  ></i>
                                                </div>
                                              </div>
                                            </div>
                                          );
                                        },
                                      )}
                                    </div>
                                  </div>
                                </Panel.Body>
                              )}
                            </Panel>

                            {this.state.otherImages &&
                            this.state.otherImages.length ? (
                              <Panel>
                                <Panel.Heading
                                  onClick={() =>
                                    this.togglePanel("showOtherDocs")
                                  }
                                >
                                  <div className="accordion-header">
                                    <span>
                                      <span
                                        className={`glyphicon arrow-icon ${
                                          showOtherDocs
                                            ? "glyphicon-chevron-up"
                                            : "glyphicon-chevron-down"
                                        }`}
                                      ></span>
                                      <span className="lot-titles">Other</span>
                                    </span>
                                  </div>
                                </Panel.Heading>
                                {showOtherDocs && (
                                  <Panel.Body>
                                    <div style={{ marginTop: "20px" }}>
                                      {this.state.otherImages.map(
                                        (doc, index) => {
                                          const fileTypeIcon =
                                            this.renderFileTypeIcon(doc);

                                          return (
                                            <div
                                              key={index}
                                              className="item-card-content"
                                            >
                                              <div className="item-card">
                                                {/* Left: icon */}
                                                <div className="left-section">
                                                  <img
                                                    src={fileTypeIcon}
                                                    alt="file icon"
                                                    className="doc-icon"
                                                  />
                                                </div>
                                                {/* Middle: file name */}
                                                <div
                                                  className="middle-section"
                                                  title={
                                                    doc.name || doc.fileName
                                                  }
                                                >
                                                  <div className="doc-title">
                                                    {getTruncatedFilename(doc)}
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          );
                                        },
                                      )}
                                    </div>
                                  </Panel.Body>
                                )}
                              </Panel>
                            ) : (
                              ""
                            )}

                            <div className="smart-app-section">
                              <div className="title">
                                SMART App
                                <p>Add the app for this product</p>
                              </div>
                              <div className="form-group">
                                <label>App name</label>
                                <input
                                  type="text"
                                  name="appName"
                                  value={this.state.appName}
                                  onChange={this.handleInputChange}
                                  placeholder="Enter app name"
                                  className="input-field"
                                  max="50"
                                  maxLength="50"
                                />
                              </div>
                              <div className="form-group">
                                <label>App URL (Android)</label>
                                <input
                                  type="text"
                                  name="androidURL"
                                  value={this.state.androidURL}
                                  onChange={this.handleInputChange}
                                  placeholder="Enter Android app URL"
                                  className="input-field"
                                  // disabled={!this.state.appName}
                                  maxLength="255"
                                />
                              </div>
                              <div className="form-group">
                                <label>App URL (iOS)</label>
                                <input
                                  type="text"
                                  name="iosURL"
                                  value={this.state.iosURL}
                                  onChange={this.handleInputChange}
                                  // disabled={!this.state.appName}
                                  placeholder="Enter iOS app URL"
                                  className="input-field"
                                  maxLength="255"
                                />
                              </div>
                              <p style={{ fontSize: 12, color: "red" }}>
                                {this.state.appError ? this.state.appError : ""}
                              </p>
                            </div>
                            <div>
                              <Link
                                to={`/projects/edit/${this.state.dynamicSegment}?lotTab=home-maintenance&tab=${this.state.tab}&toolSelection=${this.state.toolSelection}`}
                                className="navigate-to-maintenance"
                                disabled={
                                  !this.state.itemName ||
                                  !this.state.itemCategory ||
                                  !this.state.locationInHome ||
                                  !this.state.typeOfPurchase ||
                                  loading ||
                                  this.state.error ||
                                  !this.state.dynamicSegment ||
                                  !this.state.tab ||
                                  !this.state.toolSelection
                                }
                              >
                                <i
                                  className="fa fa-plus icon"
                                  aria-hidden="true"
                                ></i>
                                Add Reminder
                              </Link>
                            </div>
                          </Form>
                        </Tab.Pane>
                      </Tab.Content>
                    </Col>
                  </Row>
                </Tab.Container>
              </React.Fragment>
            )}
          </Modal.Body>
          {!this.state.showAIScan && (
            <Modal.Footer className="modal-footer-addDocument">
              {loading && (
                <div className="loading-indicator">Uploading file...</div>
              )}
              <button
                className="save-doc-btn"
                type="submit"
                onClick={this.onSubmit}
                disabled={
                  !this.state.itemName ||
                  !this.state.itemCategory ||
                  !this.state.locationInHome ||
                  !this.state.typeOfPurchase ||
                  loading ||
                  this.state.error
                }
              >
                Update Item
              </button>
            </Modal.Footer>
          )}
        </Modal>
        {this.renderPreviewModal()}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    LotDocuments: state.LotStore.LotDocuments,
  };
};

export default connect(mapStateToProps)(InventoryEditItemModal);



// WEBPACK FOOTER //
// ./src/Projects/Components/Inventory/inventoryEditItem.js